<p-confirmDialog />
<div class="flex  justify-start flex-col md:flex-row gap-5" style="min-height: 81vh">
  <div *ngIf="linkApplicationEnabled()">
    <div>
      <div>
        <div class="card todolist-card text-center">
          <i *ngIf="hasNoExternalLinks()" class="text-red-700">Avant d'échanger des taches avec notre intervenant, il est nécessaire de rattacher votre espace bénéficiaire aux logiciels de suivi, via le bouton "Lier mon dossier" présent dans le menu.</i>

          <div class="grid grid-cols-1 sm:grid-cols-11">
            <!-- Mes Tâches -->
            <div class="col-span-1 sm:col-span-5">
              <div class="px-6 py-4">
                <h1 class="text-xl text-center font-circe mb-5 text-primary">
                  {{ 'todolist.tachesTitle' | translate }}
                </h1>
                <p class="text-base font-circe">
                  {{ 'todolist.tachesDescription' | translate }}
                </p>

                <div *ngFor="let task of listTasks()">
                  <div class="flex items-center mt-5">
                    <div class="grid grid-cols-12">
                      <div class="col-span-1 mt-2">
                        <p-button
                          [styleClass]="task.realisee ? 'h-7 w-7 border-0' : 'h-7 w-7 border-gray-300 bg-[#ffffff7a]'"
                          [icon]="task.realisee ? 'pi pi-check' : ''"
                          [rounded]="true"
                          [severity]="task.realisee ? 'contrast' : null"
                          (click)="changeTaskRealisee(task.id)"
                        />
                      </div>
                      <div class="col-span-10 ml-4">
                        <div class="flex flex-col text-left">
                          <h4 [ngClass]="task.realisee ? 'text-lg font-circe text-gray-400' : 'text-lg font-circe text-primary'">
                            {{task.libelle}}
                          </h4>
                          <p [ngClass]="task.realisee ? 'text-base font-circe text-gray-400' : 'text-base font-circe text-black'">
                            {{task.description}}
                          </p>
                          <div class="flex items-center text-sm text-gray-600 mt-2">
                            <i class="pi pi-user mr-2"></i>
                            <span class="font-semibold">{{task.createur}}</span>
                            <span *ngIf="task.dateDerniereModification; else creationDate" class="ml-4 flex items-center">
                              <i class="pi pi-calendar mr-2"></i>
                              <span class="font-semibold">Modifié le : {{task.dateDerniereModification}}</span>
                            </span>
                            <ng-template #creationDate>
                              <span class="ml-4 flex items-center">
                                <i class="pi pi-calendar mr-2"></i>
                                <span class="font-semibold">{{task.dateCreation}}</span>
                              </span>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-5 mb-5 rounded-3xl border border-primary">
                </div>


              </div>
            </div>


            <!-- Ligne de séparation -->
            <div class="block sm:hidden my-4">
              <hr class="border border-surface-200 mx-8">
            </div>
            <div class="hidden sm:flex justify-center h-screen">
              <div class="w-0.5 h-full border border-surface-200"></div>
            </div>

            <!-- Informations -->
            <div class="col-span-1 sm:col-span-5">
              <div class="px-6 py-4">
                <h1 class="text-xl text-center font-circe mb-5 text-primary">
                  {{ 'todolist.InformationsTitle' | translate }}
                </h1>
                <p class="text-base font-circe">
                  {{ 'todolist.InformationsDescription' | translate }}
                </p>

                <div class="text-left mt-5" *ngFor="let information of listInformations()">
                  <h4 class="text-lg font-circe mt-5 text-primary">
                    {{ information.libelle }}
                  </h4>
                  <p class="font-circe">
                    {{ information.description }}
                  </p>
                  <div class="flex items-center text-sm text-gray-600 mt-2">
                    <i class="pi pi-user mr-2"></i>
                    <span class="font-semibold">{{ information.createur }}</span>
                    <span *ngIf="information.dateDerniereModification; else infoCreationDate" class="ml-4 flex items-center">
                      <i class="pi pi-calendar mr-2"></i>
                      <span class="font-semibold">Modifié le : {{ information.dateDerniereModification }}</span>
                    </span>
                    <ng-template #infoCreationDate>
                      <span class="ml-4 flex items-center">
                        <i class="pi pi-calendar mr-2"></i>
                        <span class="font-semibold">{{ information.dateCreation }}</span>
                      </span>
                    </ng-template>
                  </div>

                  <hr class="mt-5 mb-5 rounded-3xl border border-primary">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
